// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledWrapper } from '../Styled';
import { Table } from '@/ui';
import { Pagination } from '@/components';
import PotentialPartnersFiltersContainer from '../../containers/PotentialPartnersFiltersContainer/PotentialPartnersFiltersContainer';

// Models
import { FeedbackStatus, IFeedback } from '@/models/feedback.model';

// Helpers
import { getPotentialPartnersTableColumns } from './columns';

type TPotentialPartnersList = {
  partnersList: IFeedback[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
  onChangeStatus?: (data: { id: string; status: FeedbackStatus }) => void;
  onDelete?: (feedback: IFeedback) => void;
};

const PotentialPartnersList = ({
  isLoading,
  partnersList,
  total,
  currentPage,
  onPageChange,
  onChangeStatus,
  onDelete,
}: TPotentialPartnersList) => {
  const { t } = useTranslation(['usersList']);

  return (
    <StyledWrapper>
      <Table
        columns={getPotentialPartnersTableColumns({ t, onChangeStatus, onDelete })}
        dataSource={partnersList}
        loading={isLoading}
        scroll={{ x: 'max-content' }}
        components={{
          header: {
            wrapper: PotentialPartnersFiltersContainer,
          },
        }}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default PotentialPartnersList;
